export enum PatientSex {
  'Male neutered' = 2,
  Male = 3,
  'Female spayed' = 4,
  Female = 5,
  Unknown = 6,
}
